import QueryByProviders from "./query_by_provider.js"

export default [
  ...QueryByProviders
];
